import { render, staticRenderFns } from "./message-dialog.vue?vue&type=template&id=bb39e818"
import script from "./message-dialog.vue?vue&type=script&lang=js"
export * from "./message-dialog.vue?vue&type=script&lang=js"
import style0 from "./message-dialog.vue?vue&type=style&index=0&id=bb39e818&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports